import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@/assets/images/shareIcons/stethoscope.svg'


const _hoisted_1 = { class: "tab-settings-container tab-settings-headers h-full" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "tab-inner" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "separator w-full"
}
const _hoisted_6 = { class: "component-section w-full h-full" }
const _hoisted_7 = { class: "component-header" }
const _hoisted_8 = { class: "main-header row" }
const _hoisted_9 = {
  key: 0,
  class: "title"
}
const _hoisted_10 = {
  key: 1,
  class: "subtitle"
}
const _hoisted_11 = {
  key: 2,
  class: "subtitle sex-icon"
}
const _hoisted_12 = {
  key: 3,
  class: "subsubtitle"
}
const _hoisted_13 = {
  key: 4,
  class: "subsubtitle"
}
const _hoisted_14 = { class: "item-modal" }
const _hoisted_15 = { class: "row gap-10 w-full mleft-01 mtop-02" }
const _hoisted_16 = { class: "component-active w-full height-scroll" }
const _hoisted_17 = { id: "active-tab" }
const _hoisted_18 = { class: "component-footer w-full row-end" }

import patientActions from "@/views/patientMain/leftBar/patientActions.vue"
import editTask from '@/views/officeMain/tasks/editTask.vue';

import { ref, onMounted, getCurrentInstance, computed} from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useUiStore } from '@/stores/ui';
import SharedService from '@/services/SharedService';
import EsButton from '@/components/esButton.vue';
import {useCurrentEntryStore} from '@/stores/currentEntry'
import { format } from 'date-fns';
import { DateFormat } from '@/models/share.model';
import { NoteGroup, getGenderIcon } from '@/functions/office';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'esTabsModal',
  emits: ['changeTab', 'modal-close'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const currentEntryStore = useCurrentEntryStore();
const { t } = useI18n();
const uiStore = useUiStore();
const emits = __emit;
let tabContainer = ref(null);
let tabs = ref(null);
let activeTabIndex = ref(0);
let pathIcon = ref('');
const dropd = ref(null);

const getIcon = (icon: string, isFillIcon: boolean) => {
  return SharedService.getIcon(icon, isFillIcon, pathIcon.value);
};

const changeTab = (index: number) => {
  tabs.value.forEach((tab) => {
    tab.el?.classList.remove('active');
  });

  tabs.value[index].el?.classList.add('active');
  currentEntryStore.setPatientModalTab(tabs.value[index].keyword);
  activeTabIndex.value = index;
  emits('changeTab', index);
};

const fullName = computed(() => currentEntryStore.modalPatient.lastName + ' ' +currentEntryStore.modalPatient.firstName || '');

const age = computed(() => currentEntryStore.modalPatient.ageTerm || '');

const birthDate = computed(() => {
  const date = currentEntryStore.modalPatient.birthDate;
  return date ? format(new Date(date), DateFormat.FRONT_LONG) : '';
});

const mainLanguage = computed(() =>
  currentEntryStore.modalPatient?.languages?.[0]?.languageIso ?? ""
);

const sex = computed(() => {
  return getGenderIcon(currentEntryStore.modalPatient);
})

async function accessPatient() {
  const pwrPatient = currentEntryStore.modalPatient;
  setLoadingScreenTexts();
  if (pwrPatient.personWithRoleId !== currentEntryStore.currentPatientId) {
    currentEntryStore.clearCurrentEntry();
  }
  emits('modal-close');
  router.push({
    name: "patient",
    params: { patientId: pwrPatient.personWithRoleId }
  });
}

function setLoadingScreenTexts() {
  const pwrPatient = currentEntryStore.modalPatient;
  const loadingText = PersonService.formatName(pwrPatient.lastName, pwrPatient.firstName);
  uiStore.setLoadingScreenText(loadingText);
}


const notesToShow = computed(() => {
  const notesGroup = currentEntryStore.modalPatientNotes?.find(
    (item) => item.keyword === NoteGroup.NOTES
  );
  const tasks = notesGroup?.tasks ?? [];
  return tasks.filter((task) =>
    ["DuringShift", "EndOfShift"].includes(task.taskPriorityType)
  );
});

function openTaskModal() {
  uiStore.setModalUiId('addTaskNoteFromModalPatient')
}

function reload() {
  currentEntryStore.reloadModalPatientNotes(currentEntryStore.modalPatient.personWithRoleId);
}

onMounted(() => {
  // get all props from tabs
  const instance = getCurrentInstance();
  const tabElements = [...tabContainer.value.querySelectorAll('.estab')];
  const tabNodes = instance?.slots.default?.() ?? [];

  let firstMatchFound = false;

  // build new tab
  tabs.value = tabNodes.map((vnode, index) => {
    const props = vnode.props || {};
    pathIcon.value = props.pathIcon;

    const keyword = props.keyword || '';
    const icon = props.icon || '';
    const title = props.title || '';
    const header = props.header || '';
    const subTitle = props.subTitle || '';
    const subSubTitle = props.subSubTitle || '';
    const routeName = props.route || '';
    const separator = props.separator === true || props.separator === 'true';

    const initialTab = currentEntryStore.patientModalTab;
    if (!firstMatchFound && initialTab && keyword === initialTab) {
      activeTabIndex.value = index;
      firstMatchFound = true;
    }

    return {
      el: tabElements[index],
      keyword,
      icon,
      header,
      title,
      subTitle,
      subSubTitle,
      route: routeName,
      separator
    };
  });
  changeTab(activeTabIndex.value);
});

return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_itemModal = _resolveComponent("itemModal")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "tabContainer",
    ref: tabContainer,
    class: "h-full tabs-container"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            onClick: ($event: any) => (changeTab(index))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-content", { active: _unref(activeTabIndex) === index }])
              }, [
                (tab.icon)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: getIcon(tab.icon, _unref(activeTabIndex) === index),
                      class: "es-tab-settings-icons"
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(tab.title), 1)
              ], 2),
              (tab.separator)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_unref(tabs))
            ? (_openBlock(), _createElementBlock("h2", _hoisted_9, _toDisplayString(fullName.value), 1))
            : _createCommentVNode("", true),
          (_unref(tabs))
            ? (_openBlock(), _createElementBlock("h2", _hoisted_10, _toDisplayString(age.value), 1))
            : _createCommentVNode("", true),
          (_unref(tabs))
            ? (_openBlock(), _createElementBlock("h2", _hoisted_11, _toDisplayString(sex.value), 1))
            : _createCommentVNode("", true),
          (_unref(tabs) && mainLanguage.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_12, _toDisplayString(mainLanguage.value.toUpperCase()), 1))
            : _createCommentVNode("", true),
          (_unref(tabs))
            ? (_openBlock(), _createElementBlock("h2", _hoisted_13, _toDisplayString(birthDate.value), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dropd).value = $event)),
            openOn: "patientActionsFromAdmin"
          }, {
            dropd: _withCtx(() => [
              _createVNode(patientActions, {
                onClose: _cache[0] || (_cache[0] = ($event: any) => (dropd.value = '')),
                onAddTask: openTaskModal
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_button_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "moreVertical",
                    styles: "main-l size-l"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_buttonGroup, {
            class: "align-center border-primary mleft-15",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (accessPatient()))
          }, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("img", {
                src: _imports_0,
                class: "img-primary"
              }, null, -1)),
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.actionButton.accessPatient'),
                class: "mleft-05 txt-primary font-size-14"
              }, null, 8, ["txt"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_itemModal, { uiId: "addTaskNoteFromModalPatient" }, {
          modal: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(editTask, {
                pwrPatient: _unref(currentEntryStore).modalPatient,
                canChangePatient: false,
                onChanged: _cache[3] || (_cache[3] = ($event: any) => (reload()))
              }, null, 8, ["pwrPatient"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notesToShow.value, (task, index) => {
            return (_openBlock(), _createBlock(_component_text_item, {
              key: index,
              txt: task.taskNotes[0].noteContent,
              styles: task.taskPriorityType === 'DuringShift' ? 'main-alert' : 'main-m'
            }, null, 8, ["txt", "styles"]))
          }), 128))
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mtop-02" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(EsButton, {
          class: "action-button",
          "is-primary": false,
          label: _unref(t)('action.close'),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('modal-close')))
        }, null, 8, ["label"])
      ])
    ])
  ], 512))
}
}

})